// store.js
import { configureStore } from '@reduxjs/toolkit'
import ApiSlice from './ApiSlice'
import AppointmentSlice from './AppointmentSlice'
import BookingSlice from './BookingSlice'
import changeStateReducer from './changeStateSlice'
import LabAppointmentSlice from './LabAppointmentSlice'
import LabAppointmentApiSlice from './LabAppointmentApiSlice'

const store = configureStore({
  reducer: {
    appointment: AppointmentSlice,
    api: ApiSlice,
    bookings: BookingSlice,
    changeState: changeStateReducer,
    labAppointment: LabAppointmentSlice,
    labAppointmentApi: LabAppointmentApiSlice,
  },
})

export default store
